export const FDDI_DMS_Sales_Document = "FDDI_DMS_Sales_Document";
export const FDDI_DMS_Purchase_Document = "FDDI_DMS_Purchase_Document";
export const FDDI_Wizard_Create_New_DMS_Document = "FDDI_Wizard_Create_New_DMS_Document";
export const FDRW_Anordnungsblatt = "FDRW_Anordnungsblatt";
export const FDRW_Auftragsbuchblatt = "FDRW_Auftragsbuchblatt";
export const FDRW_Wizard = "FDRW_Wizard";
export const FDRW_Auftrag = "FDRW_Auftrag";
export const FDRW_WFInstance = "FDRW_WFInstance";
export const FDRW_Workflow_Running_Instances = "FDRW_Workflow_Running_Instances";

export const METHOD = {
    /** Weiter Zur Kontierung */
    InsertNewDoc: "InsertNewDoc",
    /** "Zurücksetzen auf Wizard" */
    RemoveCreation: "RemoveCreation",
    /** Buchungsbeschreibung auf Zeilen übernehmen */
    WritePostingDescrInLineDescr: "WritePostingDescrInLineDescr",
    /** Zeile Ausmultiplizieren */
    MultiplyLine: "MultiDuplicateLine",
    /** Splittungsring einfügen */
    ResolveSplittungsring: "ResolveSplittungsring",
    /** Beleg prüfen **/
    PostingCheck: "PostingCheck",
    /** Bestellung erzeugen */
    CreateOrderForBWF: "CreateOrderForBWF",
    /** BudgetInformationen */
    GetBudgetInfo: "GetBudgetInfo"
};

/** Explicit Used Methods on Rows */
export const ROWMETHOD = {
    DeleteLuGMAddRec: "DeleteLuGMAddRec",
    InsertLuGMAddRec: "InsertLuGMAddRec",
    ResolveDistribution: "ResolveDistribution"
};

/** Explicit Used Properties */
export const PROP = {
    /** Property Referencing the Corresponding LugmLine for a Main Line */
    AddRecLuGMEntryNo: "AddRecLuGMEntryNo",
    /** LUGm RefNo to Main Line */
    Entry_No: "Entry_No",
};
